import { render, staticRenderFns } from "./SliderHost.vue?vue&type=template&id=48ec9d58"
import script from "./SliderHost.vue?vue&type=script&lang=js"
export * from "./SliderHost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports